import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'map-mark-icon',
  templateUrl: './map-mark-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MapMarkIconComponent {}
